// --- React
import React from 'react';
// --- UI Components
import Button from '@dtci/spellbook/Button';
import {usePermissions} from '../../../utils/permissions';
import {useLoading} from '../../../utils/hooks/useLoading';
// --- API
import {datastageApi} from '../../../api';

/**
 * DownloadCellRenderer Component
 *
 * This component is a cell renderer for AG Grid that renders a clickable download button.
 * When the button is clicked, it downloads either the Clearance Memo or Clearance Report PDF.
 *
 * @returns {Function} The renderer function for AG Grid.
 **/
export const DownloadCellRenderer = (isClearanceMemo) => {


   return function Renderer({value, data}) {
       const {isLegalAdmin, isLegalTVAdmin} = usePermissions();
       const {setLoadingTrue, setLoadingFalse} = useLoading();

       const handleExport = async (foxFinancialTitleId, id, value, title) => {
           setLoadingTrue();
           const res = await datastageApi.exportClearanceMemoPDF(foxFinancialTitleId, id, isClearanceMemo, title);
           saveAs(res.data, title + (isClearanceMemo ? '' : ' Report') + '.pdf');
           setLoadingFalse();
       };

       return (!isClearanceMemo && !isLegalAdmin && !isLegalTVAdmin) ? (
           <span
               style={{
                   fontSize: 14,
                   color: '#6A8095',
                   cursor: 'not-allowed',
               }}
           >
               PDF
           </span>
       ) : (
           <Button
               key={data?.id}
               iconType="fa-regular fa-file-pdf"
               className="filter-button"
               sizeType="small"
               styleType="link"
               onClick={() => handleExport(data?.foxFinancialTitleId, data?.id, value, data?.title)}
           >
               PDF
           </Button>
       );
   };
};